import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Textfield from "@atlaskit/textfield";
import { setPaginationVariableScript } from "../utils/paginationUtil";
import { responseBasedTemplate } from "../utils/paginationTemplates";
import { setEditorSaved } from "../../../../../../../../redux/actions/integrationActions";

const ResponseBasedEditor = ({ action }) => {
  const [defaultValue, setDefaultValue] = useState("");
  const [responsePath, setResponsePath] = useState("$");
  const dispatch = useDispatch();

  useEffect(() => {
    if (action && action.pagination && action.pagination.variable && action.pagination.variable.script) {
      //regexp is space sensative, make sure the spacing is correct
      //const match = codeSnippet.match(/_jsonResponsePath="([^"]+)"/);

      const regExp = /_jsonResponsePath="([^"]+)"/;
      const responsePathFromScript = action.pagination.variable.script.match(regExp);
      if (responsePathFromScript && responsePathFromScript.length > 0) {
        setResponsePath(responsePathFromScript[1]);
      }

      const regExp2 = /_defaultValue="([^"]+)"/;
      const defaultValueFromScript = action.pagination.variable.script.match(regExp2);
      if (defaultValueFromScript && defaultValueFromScript.length > 0) {
        setDefaultValue(defaultValueFromScript[1]);
      }
    }
  }, [action]);
  const onChangeStartValue = (e) => {
    setDefaultValue(e.target.value);
    const script = responseBasedTemplate(e.target.value, responsePath);
    setPaginationVariableScript(action.pagination, script);
    dispatch(setEditorSaved(false));
  };
  const onChangeResponsePath = (e) => {
    setResponsePath(e.target.value);
    const script = responseBasedTemplate(defaultValue, e.target.value);
    setPaginationVariableScript(action.pagination, script);
    dispatch(setEditorSaved(false));
  };
  return (
    <>
      Default value: (if path is not found)
      <Textfield value={defaultValue} isCompact onChange={onChangeStartValue} />
      <p>This will be the default value of the pagination variable </p>
      JSON Path to response data/header value: (for next page/cursor/url).
      <br></br>The response data is accessed using <b>$.data</b> and headers using <b>$.headers</b> 
      <Textfield value={responsePath} isCompact onChange={onChangeResponsePath} />
      When iHub loads a new page, it will parse the resonse for the next page value (cursor, page, url ie)
    </>
  );
};

export default ResponseBasedEditor;
